import { bindOn } from 'chimera/all/plugins/eventbus/events/bind'
import { getEventScope } from 'chimera/all/plugins/eventbus/scope'
import { emit } from './emit'

/**
 * User reaches the contact information form step (PII entry).
 *
 * @type {string}
 */
export const reachedContactFormEvent = 'eb_reachedContactForm'

/**
 * Fire a reachedContactFormEvent.
 */
export function emitReachedContactFormEvent() {
  emit(reachedContactFormEvent, {
    scope: getEventScope(),
  })
}

/**
 * Add callback which is to be invoked on a reachedContactFormEvent.
 *
 * @param {Function} callback
 */
export function onReachedContactFormEvent(callback) {
  bindOn(reachedContactFormEvent, callback)
}
